import React, { useMemo, useCallback, ChangeEventHandler, memo } from 'react';
import { Moment } from 'moment';
import { isMomentValid } from '../utils';

export interface MonthProps {
  className: string;
  month: number;
  moment: Moment;
  minMoment?: Moment;
  maxMoment?: Moment;
  onChange: (month: number) => void;
}

function Month({
  className,
  month,
  moment,
  minMoment,
  maxMoment,
  onChange
}: MonthProps) {
  const months = useMemo(
    () =>
      Array.from({ length: 12 }, (v, i) => i).map(m => ({
        value: m,
        label: `${m < 9 ? '0' : ''}${m + 1}`
      })),
    []
  );
  const change = useCallback<ChangeEventHandler<HTMLSelectElement>>(
    event => onChange(+event.target.value),
    [onChange]
  );

  return (
    <select className={className} value={month} onChange={change}>
      {months.map(({ value, label }) => (
        <option
          key={value}
          value={value}
          disabled={
            isMomentValid(
              moment.clone().month(value),
              minMoment,
              maxMoment,
              'month'
            ) !== 0
          }
        >
          {label}
        </option>
      ))}
    </select>
  );
}

export default memo(Month);
